

























import Vue from "vue";

export default Vue.extend({
  name: "SiteShare",
  props: {
    page: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
  mounted() {
    this.stat("xiaozhan_wechat_tips_show", {
      pageType: this.page,
    });
  },
  methods: {
    stat(action: string, data: any) {
      this.$stat("xiaozhan", action, data);
    },
    handleHover() {
      this.stat("xiaozhan_wechat_2dcode_show", {
        pageType: this.page,
      });
    },
    handleBackTop() {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    },
  },
});
